<template>
  <b-modal
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      scrollable
      size="md"
      @hidden="handleHidden"
  >
    <div class="text-center mb-4">
      <div class="partial-icon mx-auto mb-3">
        <i class="bx bx-error"></i>
      </div>
      <h4 class="mb-2">{{ partialTitle }}</h4>
      <p class="mb-0" v-if="partialMessage">{{ partialMessage }}</p>
    </div>

    <div v-if="displayItems.length" class="results-list">
      <div
          v-for="item in displayItems"
          :key="item.key"
          class="result-row"
          :class="[item.status, { 'result-row--centered': !item.reason }]"
      >
        <div class="result-icon" :class="item.status">
          <i :class="item.status === 'success' ? 'bx bx-check' : 'bx bx-error-circle'"></i>
        </div>
        <div class="result-content">
          <div class="result-title" :class="item.status">{{ item.label }}</div>
          <div v-if="item.reason" class="result-reason">{{ item.reason }}</div>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="d-flex justify-content-end w-100">
        <b-button
            block
            class="close-action-btn"
            variant="light"
            @click="handleClose"
        >
          {{ $t('Close') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'sales-plan-bulk-action-partial-success',
  props: {
    id: {
      default: 'sales-plan-bulk-action-partial-success-modal',
    },
  },
  data() {
    return {
      options: {
        title: null,
        message: null,
        items: [],
      },
      resolvePromise: null,
    };
  },
  computed: {
    partialTitle() {
      return this.options.title || `${this.$t('Warning')}!`;
    },
    partialMessage() {
      return this.options.message || '';
    },
    displayItems() {
      return Array.isArray(this.options.items) ? this.options.items : [];
    },
  },
  methods: {
    show(options = {}) {
      return new Promise((resolve) => {
        this.options = {
          title: null,
          message: null,
          items: [],
          ...options,
        };
        this.resolvePromise = resolve;
        this.$bvModal.show(this.id);
      });
    },
    handleClose() {
      if (this.resolvePromise) {
        this.resolvePromise(true);
        this.resolvePromise = null;
      }
      this.$bvModal.hide(this.id);
    },
    handleHidden() {
      this.$emit('hidden');
      if (this.resolvePromise) {
        this.resolvePromise(true);
        this.resolvePromise = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.partial-icon {
  align-items: center;
  background: rgba(255, 193, 7, 0.14);
  border-radius: 999px;
  color: #b78103;
  display: inline-flex;
  height: 72px;
  justify-content: center;
  width: 72px;

  i {
    font-size: 40px;
    line-height: 1;
  }
}

.results-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.result-row {
  padding: 12px;
  border: 1px solid #FEC84B;
  border-radius: 8px;
  align-items: flex-start;
  display: flex;
  gap: 12px;
}

.result-row.success {
  background: rgba(25, 135, 84, 0.1);
  border-color: rgba(25, 135, 84, 0.28);
}

.result-row.warning {
  background: rgba(255, 193, 7, 0.16);
  border-color: #FEC84B;
}

.result-row--centered {
  align-items: center;
}

.result-icon {
  align-items: center;
  border-radius: 999px;
  display: inline-flex;
  flex: 0 0 24px;
  height: 24px;
  justify-content: center;
  width: 24px;

  i {
    font-size: 14px;
    line-height: 1;
  }
}

.result-icon.success {
  background: rgba(25, 135, 84, 0.16);
  color: #198754;
}

.result-icon.warning {
  background: rgba(255, 193, 7, 0.28);
  color: #b78103;
}

.result-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
}

.result-title {
  font: 600 14px/20px Inter;
  color: #7A2E0E;
}

.result-title.success {
  color: #198754;
}

.result-title.warning {
  color: #7A2E0E;
}

.result-reason {
  font: 400 14px/20px Inter;
  color: #667085;
}

::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }

  .close-action-btn {
    background-color: #f2f4f7;
    border-color: #f2f4f7;
    color: #344054;
  }
}
</style>
